import { PasswordInput, Button, Group, Box, Text } from "@mantine/core";
import { useForm } from "@mantine/form";

import { useResetPasswordMutation } from "services/api";
import { Link, useNavigate, useParams } from "react-router-dom";
import { ArrowNarrowLeft } from "tabler-icons-react";

type FormData = {
  password: string;
  confirmPassword: string;
};

const ResetPassword = () => {
  const form = useForm<FormData>({
    initialValues: {
      password: "",
      confirmPassword: "",
    },
    validate: {
      password: (value) => {
        if (value.length < 6) {
          return "密碼必須至少六位數";
        }

        if (!/[a-zA-Z]+/.test(value)) {
          return "密碼必需含有英文及數字";
        }

        if (!/[0-9]+/.test(value)) {
          return "密碼必需含有英文及數字";
        }

        return null;
      },
      confirmPassword: (value, values) =>
        value !== values.password ? "確認密碼需與密碼相同" : null,
    },
  });

  const { id } = useParams();
  const [resetPassword] = useResetPasswordMutation();

  const navigate = useNavigate();

  const handleSubmit = async (values: FormData) => {
    try {
      await resetPassword({ empNo: id, password: values.password }).unwrap();

      navigate("../users", { replace: true });
    } catch (e) {}
  };

  return (
    <Box py={8} px={36}>
      <Text
        variant="link"
        component={Link}
        color="cyan"
        to="../users"
        underline={false}
        sx={(theme) => ({
          display: "inline-flex",
          alignItems: "center",
          "&:hover": {
            borderBottom: "1px solid" + theme.colors.cyan[6],
          },
        })}
      >
        <ArrowNarrowLeft size={20} /> 返回上一頁
      </Text>
      <h2>重設密碼</h2>

      <form onSubmit={form.onSubmit(handleSubmit)}>
        <Box>
          <PasswordInput
            required
            label="密碼"
            placeholder="密碼必需含有英文及數字"
            {...form.getInputProps("password")}
          />
          <PasswordInput
            required
            label="確認密碼"
            mt="sm"
            {...form.getInputProps("confirmPassword")}
          />
        </Box>

        <Group mt="xl">
          <Button type="submit" color="cyan">
            重設密碼
          </Button>
        </Group>
      </form>
    </Box>
  );
};

export default ResetPassword;
